import AdminForm from '../../../../components/secure/admins/AdminForm'
import { AutoWidthCenter } from '../../../../components/layout/AutoWidthCenter'
import { Box, Button, Divider, Heading, HStack } from '@chakra-ui/react'
import { history } from '../../../../ApplicationRouter'

export default function CreateAdmin() {
  return (
    <AutoWidthCenter>
      <Box py="5">
        <HStack pb="5" justifyContent="space-between">
          <Heading as="h1">Create admin</Heading>
          <Button onClick={() => history.back()}>Back</Button>
        </HStack>
        <Divider />
        <AdminForm />
      </Box>
    </AutoWidthCenter>
  );
}